<template>
  <div class="sxKqItem">
    <Header
      :title="title == '考勤明细' ? title : '学生考勤具体明细'"
      type="0"
      :route="this.$route.query.list.route + '?list=' + params"
    ></Header>
    <NOdata
      v-if="(this.list && this.list.length == 0) || this.list == '[]'"
      title="未查询到考勤明细"
    ></NOdata>
    <div v-else class="list">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <p>打卡日期：{{ item.kqrq }}</p>
        <ul>
          <li
            v-for="(item1, index1) in item.kqmx"
            :key="index1"
            :class="item1.dkdd == '未打卡' ? 'wdkClass' : ''"
          >
            <p>{{ item1.kqqj }}</p>
            <span>
              {{ item1.dksj }}
            </span>
            <br />
            <span v-if="item1.dkdd != '未打卡'">
              {{ item1.dkdd }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      params: {},
      list: [],
      title: ""
    };
  },
  created() {
    this.title = this.$route.query.list.title;
    if (this.title && this.title == "考勤明细") {
      this.getListStudent();
    } else {
      this.getList();
      this.params = JSON.stringify(this.$route.query.list);
    }
  },
  methods: {
    async getList() {
      const res = await Api.getsxkqmx({
        sxkqid: this.$route.query.list.sxkqid,
        cxlx: this.$route.query.list.cxlx,
        cxnr: this.$route.query.list.cxnr,
        Xnxq: this.$route.query.list.sxkqrq
      });
      this.list = res.data;
    },
    async getListStudent() {
      const res = await Api.getsxkqmx1({
        rwfbid: this.$route.query.list.rwfbid,
        xnxq: this.$route.query.list.xnxq
      });
      this.list = res.data;
    }
  }
};
</script>

<style lang="less" scoped>
.sxKqItem .list {
  padding: 0 20px 0 20px;
  .list-item {
    background: #f8f8f8;
    border-radius: 5px;
    margin-bottom: 5%;
    padding: 20px 20px 10px 20px;
    position: relative;
    & > p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      font-weight: bolder;
      margin-bottom: 10px;
      text-align: center;
    }
    ul {
      .wdkClass {
        color: #f86969;
        border-color: #f86969;
        background-color: rgba(248, 105, 105, 0.2);
      }
      li {
        font-family: PingFangSC-Light;
        padding: 5px;
        font-size: 14px;
        color: #757da3;
        letter-spacing: 0;
        border: 1px dashed gray;
        margin-bottom: 10px;
        p {
          font-weight: bold;
          margin-bottom: 5px;
        }
      }
    }
  }
  .list-item::before {
    position: absolute;
    right: 0;
    top: 0;
    left: 0;
    height: 2px;
    background: -webkit-repeating-linear-gradient(
      135deg,
      #ff6c6c 0,
      #ff6c6c 20%,
      transparent 0,
      transparent 25%,
      #1989fa 0,
      #1989fa 45%,
      transparent 0,
      transparent 50%
    );
    background: repeating-linear-gradient(
      -45deg,
      #ff6c6c 0,
      #ff6c6c 20%,
      transparent 0,
      transparent 25%,
      #1989fa 0,
      #1989fa 45%,
      transparent 0,
      transparent 50%
    );
    background-size: 80px;
    content: "";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxKq/item.vue